<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <!-- snackbar -->
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>
    <!-- end snackbar -->

    <!-- dialog download -->
    <v-dialog v-model="dialog.download" scrollable persistent width="400">
      <v-card flat>
        <v-card-text class="text-center">
          <p class="mb-0 mt-3">Proses menyiapkan preview PDF....</p>
          <div class="mt-2">
            <v-progress-linear color="#0299B7" indeterminate rounded height="6">
            </v-progress-linear>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog download -->

    <v-row class="mt-3 px-3">
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Surat bebas lab
                </div>

                <!-- row filter -->
                <v-row class="pt-5">
                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.lab"
                      item-text="nama_laboratorium"
                      item-value="id"
                      v-model="form.lab"
                      v-on:change="onSelectLab($event)"
                      label="Laboratorium"
                      color="#0299B7"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.status"
                      item-text="status_bebas_lab"
                      item-value="kd_status_bebas_lab"
                      v-model="form.status"
                      v-on:change="onSelectStatus($event)"
                      label="Status"
                      color="#0299B7"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <!-- end row filter -->

                <!-- row  button-->
                <v-row class="mt-8 justify-space-between">
                  <v-col
                    cols="12"
                    md="8"
                    sm="6"
                    v-if="$vuetify.breakpoint.name !== 'xs'"
                  >
                    <div class="text-left font-weight-600 title ml-3">
                      Riwayat pengajuan
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :disabled="process.run"
                      outlined
                      dense
                      :hide-details="true"
                      placeholder="Cari . . ."
                      clearable
                      color="#0299B7"
                      class="mx-3"
                      v-model="form.cari"
                      @click:clear="
                        form.cari = '';
                        getList();
                      "
                      v-on:keyup.enter="getList()"
                      prepend-inner-icon="mdi-magnify"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <!-- end row button -->

                <v-card-text
                  class="pa-5 px-0"
                  style="height: calc(100vh - 195px)"
                >
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    :style="process.run ? 'height: calc(100vh - 305px)' : ''"
                    type="table-tbody"
                  >
                    <div class="table-scroll-x">
                      <v-data-table
                        :headers="headers"
                        :items="row"
                        :items-per-page="10"
                        class="elevation-1 required table-scroll-x__table"
                      >
                      <template v-slot:[`item.status`]="{ item }">
                        <td>
                          <span :class="getStatusClass(item.status)">{{
                            item.status
                          }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.status_verif`]="{ item }">
                        <td>
                          <span
                            class="status-verif-badge"
                            :class="getStatusVerifClass(item.flag_verif)"
                          >
                            {{ getStatusVerifText(item.flag_verif) }}
                          </span>
                        </td>
                      </template>
                      <template v-slot:[`item.tgl_verif`]="{ item }">
                        <td>{{ getTanggalVerif(item.tgl_verif) }}</td>
                      </template>
                      <template v-slot:[`item.aksi`]="{ item }">
                        <v-tooltip top v-if="item.kd_status_bebas_lab === 3">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="handleBeforeDownload(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <div
                                class="d-flex align-center text-capitalize body-2"
                              >
                                <img
                                  :src="
                                    require('@/assets/image/download_pdf.png')
                                  "
                                  alt=""
                                />
                              </div>
                            </v-btn>
                          </template>
                          <span>Surat bebas lab</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.detail"
                              :loading="process.detail"
                              @click="toPage(item, 'detail', 'detail')"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Detail</span>
                        </v-tooltip>
                        <v-tooltip top v-if="item.kd_status_bebas_lab === 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="30"
                              color="orange"
                              @click="toPage(item, 'edit', 'edit')"
                              v-bind="attrs"
                              v-on="on"
                              class="text-capitalize color-first pa-0 mx-1"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                      </template>
                      </v-data-table>
                    </div>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card-text>

              <!-- pdf -->
              <div>
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="false"
                  :preview-modal="true"
                  :paginate-elements-by-height="1400"
                  filename="Surat Bebas Lab"
                  :pdf-quality="2"
                  :manual-pagination="false"
                  pdf-format="a4"
                  :pdf-margin="10"
                  pdf-orientation="portrait"
                  pdf-content-width="800px"
                  ref="html2Pdf"
                >
                  <section slot="pdf-content">
                    <Pdf
                      :parameter="nilai_parameter"
                      ref="pdf"
                      v-model="files"
                    />
                  </section>
                </vue-html2pdf>
              </div>
              <!-- end pdf -->
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get } from "@/service/Axios";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import Pdf from "@/components/Pdf.vue";
export default {
  mixins: [statusMixin],
  data() {
    return {
      detailData: {},
      dialog: {
        download: false
      },
      nilai_parameter: "surat",
      form: {
        status: "",
        cari: "",
        lab: ""
      },
      list: {
        status: [],
        lab: []
      },
      process: {
        run: false
      },
      files: null,
      isEdit: false,
      isUII: false,
      row: [],
      headers: [
        { text: "No.", value: "nomor", sortable: false },
        { text: "NIM", value: "nim", sortable: false },
        { text: "Nama", value: "nama", sortable: false },
        { text: "Program studi", value: "program_studi", sortable: false },
        {
          text: "Tanggal pengajuan",
          value: "tanggal_pengajuan",
          sortable: false
        },
        { text: "Lab", value: "nama_lab", sortable: false },
        { text: "Status pembayaran", value: "status", sortable: false },
        {
          text: "Status verif",
          value: "status_verif",
          sortable: false,
          width: "130px"
        },
        { text: "Tanggal verif", value: "tgl_verif", sortable: false },
        {
          text: "Proses selanjutnya",
          value: "proses_selanjutnya",
          sortable: false
        },
        {
          text: "Aksi",
          value: "aksi",
          align: "center",
          width: "12%"
        }
      ],
      hasDetail: false,
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },

  components: {
    Snackbar,
    Pdf
  },
  watch: {
    files: {
      handler: function () {
        this.dialog.download = this.files.add;
      },
      deep: true
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.access_token;
    },
    roles() {
      return this.$store.state.roles;
    }
  },

  mounted() {
    TokenService.removeUUID(TokenService.getUuid());
    this.cekUserSelf();
  },
  methods: {
    getStatusVerifText(flagVerif) {
      return Number(flagVerif) === 1 ? "Sudah verif" : "Belum verif";
    },

    getStatusVerifClass(flagVerif) {
      return Number(flagVerif) === 1
        ? "status-pembayaran-terverifikasi"
        : "status-ditolak";
    },

    getTanggalVerif(tglVerif) {
      return tglVerif ? this.$callbackdate(tglVerif) : "-";
    },

    async cekUserSelf() {
      this.process.run = true;
      try {
        const response = await get(`user/self`);
        if (response.status === 200) {
          const res = response.data.data;
          this.detailData = res;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.process.run = false;
        this.fetch();
      }
    },

    async fetch() {
      const data = JSON.parse(localStorage.getItem("filter"));
      if (data) {
        const { form } = this;
        this.hasDetail = true;
        form.status = data.status;
        form.lab = data.lab;
        localStorage.removeItem("filter");
      }
      const email = this.user.email;
      this.isUII = email.endsWith("uii.ac.id") ? false : true;
      await Promise.all([this.getLab()]);
    },

    getLab() {
      let lab = this.detailData.admin;
      try {
        for (let i = 0; i < lab.length; i++) {
          const element = lab[i];
          this.list.lab.push({
            id: element.lab.id,
            kd_laboratorium: element.lab.kdLaboratorium,
            nama_laboratorium: element.lab.namaLaboratorium
          });
        }
        // this.list.lab.unshift({
        //   id: 'all',
        //   kd_laboratorium: 'all',
        //   nama_laboratorium: 'Semua',
        // });
        this.form.lab = this.hasDetail
          ? this.form.lab
          : this.form.lab === undefined
          ? this.list.lab[0].id
          : this.list.lab[0].id;
      } catch (error) {
        console.log(error);
      } finally {
        this.getStatus();
      }
    },

    async getStatus() {
      try {
        this.process.run = true;
        const response = await get(`lab-free-status`);
        if (response.status === 200) {
          const res = response.data.data;
          this.process.run = false;
          const status = res.map((el) => ({
            id: el.id,
            kd_status_bebas_lab: el.kdStatusBebasLab,
            status_bebas_lab: el.statusBebasLab,
            proses_selanjutnya: el.prosesSelanjutnya
          }));
          status.unshift({
            id: "all",
            kd_status_bebas_lab: "all",
            status_bebas_lab: "Semua"
          });
          this.list.status = status;
          this.form.status = this.hasDetail
            ? this.form.status
            : this.form.status === undefined
            ? status[0].id
            : status[0].id;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.process.run = false;
        this.getList();
      }
    },

    // async getList() {
    //   try {
    //     this.process.run = true;
    //     const params = {
    //       search: this.form.cari,
    //       id_status_bebas_lab: this.form.status,
    //       // id_laboratorium: this.detailData.admin[0].lab.id,
    //       // role: this.roles,
    //       flag_officer: '1'
    //     }
    //     const { data, status } =  await get('submission-lab-free', { params })
    //     if (status === 200 && data.data) {
    //       const row = data.data.map((item, index) => ({
    //         no: index + 1,
    //         tanggal_pengajuan: `${this.$callbackdate(item.createdAt)}`,
    //         status: item.statusSubmission.statusBebasLab,
    //         proses_selanjutnya: item.statusSubmission.prosesSelanjutnya,
    //         kd_status_bebas_lab: item.statusSubmission.kdStatusBebasLab,
    //         uuid: item.uuid
    //       }));
    //       this.row = row;
    //     }
    //   } catch (error) {
    //     console.error(error)
    //   } finally {
    //     this.process.run = false;
    //   }
    // },

    async getList() {
      try {
        this.process.run = true;
        const params = {
          search: this.form.cari,
          id_status_bebas_lab: this.form.status,
          flag_officer: "1"
        };

        const { data, status } = await get("submission-lab-free", { params });

        if (status === 200 && data.data) {
          let rows = [];
          data.data.forEach((element, index) => {
            element.detail.forEach((detail) => {
              if (detail.idLaboratorium === this.form.lab) {
                rows.push({
                  nomor: index + 1,
                  id_lab: detail.idLaboratorium,
                  nama_lab: detail.laboratory.namaLaboratorium,
                  nim: detail.userRequest?.noInduk,
                  nama: detail.userRequest?.nama,
                  program_studi: detail.userRequest?.namaProgramStudi || "-",
                  verifikator: detail.user ? detail.user.nama : "-",
                  tanggal_pengajuan: `${this.$callbackdate(element.createdAt)}`,
                  flag_verif: detail.flagVerif,
                  tgl_verif: detail.tglVerif,
                  catatan: detail.catatan || "-",
                  status: element.statusSubmission.statusBebasLab,
                  proses_selanjutnya:
                    element.statusSubmission.prosesSelanjutnya,
                  kd_status_bebas_lab:
                    element.statusSubmission.kdStatusBebasLab,
                  uuid: element.uuid
                });
              }
            });
            this.row = rows;
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.process.run = false;
      }
    },

    onSelectLab(val) {
      this.form.lab = val;
      this.getList();
    },

    onSelectStatus(val) {
      this.form.status = val;
      this.getList();
    },

    handleBeforeDownload(data) {
      this.dialog.download = true;
      this.getInvoicePrint(data, this.$refs.html2Pdf);
    },

    async getInvoicePrint(data, ref) {
      try {
        const params = {
          uuid: data.uuid,
          flag_officer: "1",
          id_laboratorium: data.id_lab
        };
        const response = await get(`submission-lab-free`, { params });
        if (response.status === 200) {
          const res = response.data.data;
          this.$store.dispatch("getDataPdf", res);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.pdf.downloadPdf(data, ref);
      }
    },

    toPage(val, type, page) {
      const { form } = this;
      const data = {
        status: form.status,
        lab: form.lab
      };
      localStorage.setItem("filter", JSON.stringify(data));
      TokenService.setUuid(val.uuid);
      try {
        TokenService.setUuid(val.uuid);
        let path;
        path =
          page === "detail"
            ? "/surat-laboran/ajukan/detail"
            : "/surat-laboran/ajukan/edit";
        this.$router.push({ path: path });
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
.table-scroll-x {
  overflow-x: auto;
  width: 100%;
}

.table-scroll-x__table {
  min-width: 1200px;
}

.status-verif-badge {
  display: inline-block;
  min-width: 95px;
  text-align: center;
  white-space: nowrap;
}
</style>
